// Console theme (D-066), as in the vendor admin (DESIGN_SYSTEM §12.1): an explicit choice sets
// data-theme on <html>, stored per device. The console starts light, like the vendor dashboard, until
// the owner picks "Match device" or "Dark" in the account menu.
export type ThemeChoice = "system" | "light" | "dark";
const KEY = "ady.console.theme";

export function readTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "system" || v === "dark" ? v : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  try {
    localStorage.setItem(KEY, choice);
  } catch {
    // Storage blocked (private mode): the choice lasts for this page only.
  }
}
